import { useBrandingStore } from '~stores/useBrandingStore'


interface DocsTopic {
  selector: string
  url: string
}

let docsTopics: undefined | DocsTopic[]

const DOCS_URL = '/docs'
const KEY_F1 = 'F1'

export function useDocs () {
  const { getDocsUrl } = useBrandingStore()
  const customDocsUrl = getDocsUrl()

  async function ensureTopics () {
    if (docsTopics) return docsTopics
    const response = await window.fetch('/config/docs-topics.json')
    docsTopics = await response.json()
    return docsTopics as DocsTopic[]
  }

  function helpListener (event: KeyboardEvent): void {
    if (event.isComposing || event.code !== KEY_F1) return
    event.preventDefault()
    openDocs()
  }

  async function openDocs () {
    if (customDocsUrl) {
      window.open(customDocsUrl, '_blank')
      return
    }

    const topics = await ensureTopics()

    let url = ''
    for (const topic of topics) {
      if (document.querySelector(topic.selector)) {
        url = topic.url
        break
      }
    }

    window.open(url ? `${DOCS_URL}/${url}` : DOCS_URL, '_blank')
  }

  return {
    docsUrl: customDocsUrl ?? DOCS_URL,
    helpListener,
    openDocs,
  }
}
